// extracted by mini-css-extract-plugin
export default {"menu-tabs":"menu-tabs__2Shnn","menu-tab-item":"menu-tab-item__2msAl","menu-tab-link":"menu-tab-link__3KZ4D","link-active":"link-active__1BcqM"};